import { cn } from '../../utils/cn';

const DOT_COUNT = 3;

/**
 * Three dots that breathe in sequence — the Button's loading indicator (ruling
 * 2026-09-03: replaces armory's stepping text ellipsis; the Forge has no loading
 * state). Every dot runs the same `animate-breathe` keyframes (opacity and scale,
 * `--duration-breathe` per cycle) offset by a third of a period, so one dot peaks
 * at a time and the pulse travels left to right. The offsets are negative
 * `animation-delay`s computed from the duration token, so every dot is already
 * mid-cycle on the first frame — no dot waits at full brightness for its turn.
 * `currentColor` fill follows the button ink; `motion-reduce` shows three still
 * dots. Decorative: the button's `loadingText` and `aria-busy` carry the meaning.
 */
export function LoadingDots({ className }: { className?: string }) {
  return (
    <span aria-hidden className={cn('inline-flex items-center gap-0.5', className)}>
      {Array.from({ length: DOT_COUNT }, (_, index) => {
        // Phase steps ahead of the cycle start: 1, 0, 2 for dots 0, 1, 2 — so the
        // peaks land at 1/6, 1/2 and 5/6 of the period, left to right.
        const phaseSteps = (DOT_COUNT + 1 - index) % DOT_COUNT;
        return (
          <span
            key={phaseSteps}
            className="animate-breathe size-1 rounded-full bg-current motion-reduce:animate-none"
            style={{
              animationDelay: `calc(var(--duration-breathe) * -${String(phaseSteps)} / ${String(DOT_COUNT)})`,
            }}
          />
        );
      })}
    </span>
  );
}
